import e, { useRef as n, useState as r, useEffect as t } from "react";
import { Icon as a } from "../../general/Icon/Icon.js";
import { AppLauncherPanelSection as o } from "./AppLauncherPanelSection.js";
import { KASEYA as l } from "../../../constants/kaseya.js";
import { DotLoader as c } from "../../loaders/DotLoader/DotLoader.js";
import { t as i } from "../../../i18/index.js";
import s from "../../../../node_modules/classnames/index.js";
function u(e, n) {
  (null == n || n > e.length) && (n = e.length);
  for (var r = 0, t = Array(n); r < n; r++) t[r] = e[r];
  return t;
}
function m(e, n) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, n) {
    var r,
      t,
      a = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != a) {
      var o = [],
        l = !0,
        c = !1;
      try {
        for (a = a.call(e); !(l = (r = a.next()).done) && (o.push(r.value), !n || o.length !== n); l = !0);
      } catch (e) {
        c = !0, t = e;
      } finally {
        try {
          l || null == a.return || a.return();
        } finally {
          if (c) throw t;
        }
      }
      return o;
    }
  }(e, n) || function (e, n) {
    if (e) {
      if ("string" == typeof e) return u(e, n);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if ("Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r) return Array.from(r);
      if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return u(e, n);
    }
  }(e, n) || function () {
    throw TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function p(u) {
  var p = u.apps,
    f = u.onClose,
    d = n(null),
    h = m(r([]), 2),
    v = h[0],
    y = h[1],
    E = m(r([]), 2),
    g = E[0],
    b = E[1],
    j = m(r(!0), 2),
    A = j[0],
    N = j[1];
  t(function () {
    var e = function e(_e) {
      var n;
      (null === (n = d.current) || void 0 === n ? void 0 : n.contains(_e.target)) || f();
    };
    return document.addEventListener("mousedown", e), function () {
      document.removeEventListener("mousedown", e);
    };
  }, []);
  var k = function k(e) {
    var n = [],
      r = [];
    e.forEach(function (e) {
      e.isPinned ? n.push(e) : r.push(e);
    }), y(n), b(r);
  };
  return t(function () {
    p && (k(p), N(!1));
  }, [p]), e.createElement("div", {
    className: s("launcher-panel", A ? "launcher-panel--loading" : ""),
    ref: d
  }, e.createElement("div", {
    className: "launcher-panel__header"
  }, e.createElement("a", {
    className: "kaseya-link",
    target: "_blank",
    href: l.ONEURL
  }, e.createElement("span", null, i("app-launcher.kaseya-one")), e.createElement(a, {
    name: "external-link",
    regular: !0
  })), e.createElement("div", {
    className: "app-launcher-panel__icon",
    onClick: f
  })), A ? e.createElement(c, {
    dark: !0
  }) : e.createElement("div", {
    className: "launcher-panel__sections"
  }, e.createElement(o, {
    apps: v,
    header: i("app-launcher.my-it-complete"),
    className: "my-it-complete-section"
  }), e.createElement(o, {
    apps: g,
    header: i("app-launcher.discover-more"),
    className: "discover-more-section"
  })));
}
p.displayName = "AppLauncherPanel";
export { p as AppLauncherPanel };